import { hasApiErrorCode } from '@/utils/apiError'

/**
 * HTTP 409 — a reversão de uma REPROVAÇÃO de Registro de Atividade não cabe mais porque o
 * emissor já reenviou um registro novo em cima dela (decisão do PO, 01/10/2026: a
 * reprovação deixou de ser terminal; o backend reverte `REJECTED → PENDING_AUDIT` e
 * cancela a solicitação de reenvio ainda não enviada, mas recusa quando o reenvio já
 * aconteceu). A mensagem do backend diz o que fazer: auditar o novo registro.
 */
export const ACTIVITY_REJECTION_SUPERSEDED = 'ACTIVITY_REJECTION_SUPERSEDED'

/**
 * Fallback do `notifyError` para este código quando o body não traz `message` — a mesma
 * frase que o backend usa, para a instrução (auditar o sucessor) nunca se perder.
 */
export const ACTIVITY_REJECTION_SUPERSEDED_FALLBACK_MESSAGE =
  'O registro reprovado já foi substituído por um novo envio. Audite o novo registro.'

// `unknown` de propósito: o parâmetro de um `catch` é `unknown` sob `strict`, e o guard
// precisa ser chamável direto no caçador de erro sem um re-cast antes. A verificação é
// por CÓDIGO e não por status HTTP: o 409 também é o status do `ALREADY_IN_STATUS`, e o
// que distingue os dois é o `code`. `hasApiErrorCode` já desembrulha `ServiceError`.
export const isActivityRejectionSupersededError = (error: unknown): boolean =>
  hasApiErrorCode(error, ACTIVITY_REJECTION_SUPERSEDED)
